import { Service } from "@catalogue/domain/models/service.model";
import { injectable } from "inversify";
import { ServiceDto } from "../../dto/service.dto";
import { CreateServiceDto } from "@catalogue/data/dto/create-service.dto";



@injectable()
export class ServiceMapper {
    map(dto: ServiceDto): Service | undefined {
        if (!dto) return undefined;

        return {
            id: dto.id,
            entity: dto.entity,
            category: dto.category,
            createdAt: dto.created_at,
        };
    }

    mapToCreateBody(service: Omit<Service, "id" | "createdAt">): CreateServiceDto {
        return {
            entity: service.entity,
            category: service.category,
        };
    }
}